export default "__VITE_ASSET__5b97ihT0__"